<!-- FileComponent.vue -->
<template>
    <div>
      <a :href="url" download class="file-download">
        {{ $t('chat.download') }}
      </a>
    </div>
  </template>
  
  <script>

  export default {
    props: ['url']
  }
  </script>
  
  <style>
  .file-download {
    padding: 10px;
    background-color: #007bff;
    color: white;
    text-decoration: none;
    border-radius: 5px;
  }
  .file-download:hover {
    background-color: #0056b3;
  }
  </style>
  